import React, { Component } from "react";
import { Link } from "react-router-dom";
import { _t } from "../util/Translator";

class InscripcionAceptadaConfirmationScreen extends Component {
  state = {};
  render() {
    return (
      <div className="site-section">
        <div className="container col-md-12">
          <div className="col-md-12">
            <h1>{_t("inscripcionAccepted.title")}</h1>
          </div>
          <div className="col-md-12">
            <p>
              {_t("inscripcionAccepted.statement")} 
            </p>            
          </div>
        </div>
      </div>
    );
  }
}

export default InscripcionAceptadaConfirmationScreen;
